import "./PanelMonitoreoOperativo.css";
import React, { useContext } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faChartSimple,
  faCircleCheck,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-bootstrap";

const formatearMoneda = (valor) =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
  }).format(valor || 0);

const BienvenidaMonitoreoOperativo = ({ resumen, titulo }) => {
  const { darkMode } = useContext(DarkModeContext);
  const datos = resumen || {
    totalCuits: 0,
    cuitsEnAlerta: 0,
    cuitsConCaida: 0,
    cuitsConSeguimiento: 0,
    totalTerminales: 0,
    montoFacturadoDia: 0,
  };

  const contenedorClase = darkMode
    ? "monitoreo-operativo-panel-dark"
    : "monitoreo-operativo-panel";

  const tarjetaClase = darkMode
    ? "monitoreo-operativo-kpi-dark"
    : "monitoreo-operativo-kpi";

  return (
    <section className="container">
      <div className={`${contenedorClase} px-4 py-4`}>
        <Row className="g-3 align-items-stretch">
          <Col xl={2} lg={4} md={6}>
            <div className={`${tarjetaClase} p-3 d-flex flex-column justify-content-center`}>
              <span className="lato-regular fs-14">{titulo}</span>
              <span className="heavy-900 fs-22 color-verde line-h-26 mt-2">Monitoreo Operativo</span>
            </div>
          </Col>
          <Col xl={2} lg={4} md={6}>
            <div className={`${tarjetaClase} p-3 d-flex flex-column justify-content-center`}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FontAwesomeIcon className="color-verde" icon={faStore} />
                <span className="lato-regular fs-14">CUITs monitoreados</span>
              </div>
              <span className="lato-bold fs-28">{datos.totalCuits}</span>
            </div>
          </Col>
          <Col xl={2} lg={4} md={6}>
            <div className={`${tarjetaClase} p-3 d-flex flex-column justify-content-center`}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FontAwesomeIcon className="color-rojo" icon={faBell} />
                <span className="lato-regular fs-14">En alerta</span>
              </div>
              <span className="lato-bold fs-28 color-rojo">{datos.cuitsEnAlerta}</span>
            </div>
          </Col>
          <Col xl={2} lg={4} md={6}>
            <div className={`${tarjetaClase} p-3 d-flex flex-column justify-content-center`}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FontAwesomeIcon className="color-naranja" icon={faChartSimple} />
                <span className="lato-regular fs-14">Con caida</span>
              </div>
              <span className="lato-bold fs-28 color-naranja">{datos.cuitsConCaida}</span>
            </div>
          </Col>
          <Col xl={2} lg={4} md={6}>
            <div className={`${tarjetaClase} p-3 d-flex flex-column justify-content-center`}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FontAwesomeIcon className="color-verde" icon={faCircleCheck} />
                <span className="lato-regular fs-14">Seguimiento activo</span>
              </div>
              <span className="lato-bold fs-28 color-verde">{datos.cuitsConSeguimiento}</span>
            </div>
          </Col>
          <Col xl={2} lg={4} md={6}>
            <div className={`${tarjetaClase} p-3 d-flex flex-column justify-content-center`}>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FontAwesomeIcon className="color-verde" icon={faChartSimple} />
                <span className="lato-regular fs-14">Facturacion del dia</span>
              </div>
              <span className="lato-bold fs-22 color-verde">{formatearMoneda(datos.montoFacturadoDia)}</span>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default BienvenidaMonitoreoOperativo;
